import Main from '@/components/main';
import DistributionStationManagement from './distributionStation-management';

export default {
    path: '/distributionStation-management',
    name: 'distributionStation-management',
    meta: {
        icon: 'ios-man',
        title: '转运站管理',
        showAlways: true
    },
    component: Main,
    children: [
        ...DistributionStationManagement,
        {
            path: 'station-compensation-list',
            name: 'station-compensation-list',
            meta: {
                icon: 'ios-apps',
                title: '售后退款',
                notCache: true,
                access: ['D'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/compensation/station-compensation-list')
        }
    ]
};
